<template>
  <div>
    <login
      v-if="!user"
      :organization-type="organizationType"
      @login="handleLoginModalState"
      @signIn="handleSignInModalState"
    />
    <logged-in
      v-else
      :user="user"
      :organization-type="organizationType"
      @login="handleLoginModalState"
    />
    <login-modal
      :show="openLoginModal"
      :organization-type="organizationType"
      @close="handleLoginModalState"
      @refetchUser="handleRefetchUser"
    />
    <sign-in-modal
      :show="openSignInModal"
      :organization-type="organizationType"
      @close="handleSignInModalState"
      @openLoginModal="handleLoginModalState"
    />
  </div>
</template>

<script>
import LoggedIn from '@/components/accreditations/organization-store/user/status/LoggedIn.vue'
import Login from '@/components/accreditations/organization-store/user/status/Login.vue'
import SignInModal from '@/components/accreditations/organization-store/user/modals/sign-in/SignInModalContainer.vue'
import LoginModal from '@/components/accreditations/organization-store/user/modals/LoginModal.vue'
import { OrganizationType } from '@/types'
export default {
  name: 'user-container',
  components: {
    LoginModal,
    SignInModal,
    Login,
    LoggedIn,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    organizationType: String,
  },
  data() {
    return {
      openLoginModal: false,
      openSignInModal: false,
    }
  },
  methods: {
    handleLoginModalState() {
      this.openLoginModal = !this.openLoginModal
      this.openSignInModal = false
    },
    handleSignInModalState() {
      this.openSignInModal = !this.openSignInModal
    },
    closeModals() {
      this.openSignInModal = false
      this.openLoginModal = false
    },
    async handleRefetchUser() {
      this.$emit('refetchUser')
      this.closeModals()
    },
  },
}
</script>

<style scoped></style>
